import Toast from './Toast'
window.Toast = Toast
